import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700&family=Playfair+Display:ital,wght@0,500;0,600;1,500&display=swap');

.fb-wrap{--navy:#070b16;--panel:#0a1124;--gold:#c9a84c;--gold-lt:#e7ca72;--gold-dk:#8f6f2c;--teal:#37d0c4;--ink:#06090f;--text:#e9edf5;--muted:#9aa6bc;--line:rgba(201,168,76,.30);
  min-height:100vh;width:100%;box-sizing:border-box;
  background:
    radial-gradient(1100px 520px at 50% -8%, #16203c 0%, rgba(22,32,60,0) 60%),
    radial-gradient(820px 620px at 100% 120%, rgba(55,208,196,.10) 0%, rgba(55,208,196,0) 55%),
    linear-gradient(180deg,#070b16,#05070f);
  display:flex;align-items:flex-start;justify-content:center;padding:30px 16px 60px;
  font-family:'Playfair Display',Georgia,serif;color:var(--text);-webkit-font-smoothing:antialiased;}
.fb-frame{position:relative;width:100%;max-width:640px;background:linear-gradient(180deg,var(--panel),#070c1a);
  border:1px solid var(--line);border-radius:14px;padding:56px 42px 40px;
  box-shadow:0 40px 120px rgba(0,0,0,.6), inset 0 0 0 4px rgba(201,168,76,.05);}
.fb-frame::before{content:'';position:absolute;inset:9px;border:1px solid rgba(201,168,76,.16);border-radius:9px;pointer-events:none;}
.fb-corner{position:absolute;width:84px;height:84px;}
.fb-corner-tl{top:5px;left:5px;}
.fb-corner-tr{top:5px;right:5px;transform:scaleX(-1);}
.fb-corner-bl{bottom:5px;left:5px;transform:scaleY(-1);}
.fb-corner-br{bottom:5px;right:5px;transform:scale(-1,-1);}
.fb-center{text-align:center;position:relative;z-index:1;}
.fb-logo{display:block;margin:0 auto 8px;width:188px;max-width:62%;height:auto;filter:drop-shadow(0 10px 26px rgba(0,0,0,.5));}
.fb-kicker{font-family:'Cinzel',serif;color:var(--teal);font-size:12px;letter-spacing:5px;font-weight:600;text-transform:uppercase;}
.fb-divider{display:flex;align-items:center;justify-content:center;gap:14px;margin:18px auto;max-width:300px;}
.fb-divider i{height:1px;flex:1;background:linear-gradient(90deg,transparent,var(--line));}
.fb-divider i.r{background:linear-gradient(270deg,transparent,var(--line));}
.fb-diamond{width:7px;height:7px;transform:rotate(45deg);background:var(--gold);box-shadow:0 0 0 3px rgba(201,168,76,.10);}
.fb-headline{font-family:'Playfair Display',serif;font-weight:600;font-size:38px;line-height:1.08;margin:4px 0 12px;
  background:linear-gradient(180deg,var(--gold-lt),var(--gold) 60%,var(--gold-dk));-webkit-background-clip:text;background-clip:text;color:transparent;}
.fb-lead{color:var(--muted);font-size:15px;line-height:1.65;max-width:460px;margin:0 auto;}

.fb-qr-box{display:inline-block;padding:14px;background:#fff;border-radius:12px;box-shadow:0 14px 40px rgba(0,0,0,.45);}
.fb-qr-box img{display:block;width:172px;height:172px;}
.fb-qr-caption{font-family:'Cinzel',serif;color:var(--muted);font-size:11px;letter-spacing:2px;text-transform:uppercase;margin-top:11px;}

.fb-form{margin-top:4px;text-align:left;}
.fb-q{padding:20px 0;border-bottom:1px solid rgba(201,168,76,.10);}
.fb-q:last-of-type{border-bottom:none;}
.fb-q-num{font-family:'Cinzel',serif;font-size:10px;letter-spacing:2px;color:var(--teal);text-transform:uppercase;margin-bottom:7px;}
.fb-q-text{font-family:'Playfair Display',serif;font-size:16.5px;line-height:1.45;color:var(--text);margin-bottom:14px;}
.fb-req{color:var(--gold);}

.fb-stars{display:flex;align-items:center;gap:5px;}
.fb-star{background:none;border:none;padding:3px;cursor:pointer;line-height:0;transition:transform .12s;}
.fb-star:hover{transform:scale(1.12);}
.fb-star svg{display:block;}
.fb-star-val{font-family:'Cinzel',serif;font-size:13px;letter-spacing:1px;color:var(--gold-lt);margin-left:9px;}

.fb-likert{display:flex;gap:8px;}
.fb-lk{flex:1;min-height:56px;background:rgba(255,255,255,.02);border:1px solid var(--line);border-radius:9px;padding:9px 6px;
  font-family:'Cinzel',serif;font-size:11px;letter-spacing:.3px;line-height:1.3;color:var(--muted);cursor:pointer;transition:.15s;text-align:center;}
.fb-lk:hover{border-color:rgba(201,168,76,.6);color:var(--text);}
.fb-lk.on{background:linear-gradient(180deg,var(--gold-lt),var(--gold));color:var(--ink);border-color:var(--gold);font-weight:600;box-shadow:0 8px 22px rgba(201,168,76,.22);}

.fb-choices{display:flex;flex-direction:column;gap:9px;}
.fb-choice{width:100%;min-height:50px;box-sizing:border-box;text-align:left;background:rgba(255,255,255,.02);border:1px solid var(--line);
  border-radius:9px;padding:13px 16px;font-family:'Playfair Display',serif;font-size:14.5px;color:var(--text);cursor:pointer;transition:.15s;}
.fb-choice:hover{border-color:rgba(201,168,76,.6);background:rgba(201,168,76,.05);}
.fb-choice.on{background:linear-gradient(180deg,var(--gold-lt),var(--gold));color:var(--ink);border-color:var(--gold);font-weight:600;}

.fb-textarea{width:100%;box-sizing:border-box;background:rgba(255,255,255,.03);border:1px solid var(--line);border-radius:10px;
  padding:13px 15px;font-size:14.5px;color:var(--text);font-family:'Playfair Display',Georgia,serif;line-height:1.6;resize:vertical;min-height:88px;transition:.15s;}
.fb-textarea::placeholder{color:rgba(154,166,188,.5);}
.fb-textarea:focus{outline:none;border-color:var(--gold);box-shadow:0 0 0 3px rgba(201,168,76,.14);background:rgba(255,255,255,.05);}
.fb-count{text-align:right;font-family:'Cinzel',serif;font-size:10px;letter-spacing:1px;color:rgba(154,166,188,.6);margin-top:6px;}

.fb-inline-err{color:#f0b4b4;font-size:12.5px;margin-top:9px;}
.fb-error{background:rgba(220,80,80,.10);border:1px solid rgba(220,80,80,.4);color:#f0b4b4;border-radius:10px;padding:11px 14px;font-size:13.5px;margin-bottom:14px;}
.fb-submit{width:100%;margin-top:22px;padding:15px;border:none;border-radius:11px;cursor:pointer;
  font-family:'Cinzel',serif;font-size:15px;letter-spacing:1.5px;text-transform:uppercase;color:var(--ink);font-weight:600;
  background:linear-gradient(180deg,var(--gold-lt),var(--gold) 70%,var(--gold-dk));box-shadow:0 12px 30px rgba(201,168,76,.28);transition:.15s;}
.fb-submit:hover:not(:disabled){filter:brightness(1.05);}
.fb-submit:disabled{opacity:.45;cursor:default;box-shadow:none;}
.fb-fine{text-align:center;color:var(--muted);font-size:12px;margin-top:13px;}
.fb-footer{margin-top:22px;text-align:center;font-family:'Cinzel',serif;color:var(--teal);font-size:11px;letter-spacing:2.5px;text-transform:uppercase;}

.fb-tick{width:62px;height:62px;border-radius:50%;margin:4px auto 12px;display:flex;align-items:center;justify-content:center;
  border:2px solid var(--gold);color:var(--gold-lt);font-size:30px;background:rgba(201,168,76,.08);}
.fb-thanks{font-family:'Playfair Display',serif;font-weight:600;font-size:28px;margin:6px 0;
  background:linear-gradient(180deg,var(--gold-lt),var(--gold-dk));-webkit-background-clip:text;background-clip:text;color:transparent;}
.fb-spin{width:34px;height:34px;margin:14px auto;border:2px solid rgba(201,168,76,.2);border-top-color:var(--gold);border-radius:50%;animation:fbspin .8s linear infinite;}
@keyframes fbspin{to{transform:rotate(360deg)}}
.fb-closed{width:66px;height:66px;border-radius:50%;margin:6px auto 14px;display:flex;align-items:center;justify-content:center;
  border:1px solid var(--line);background:rgba(201,168,76,.06);animation:fbpulse 2.6s ease-in-out infinite;}
@keyframes fbpulse{0%,100%{opacity:.55;transform:scale(1)}50%{opacity:1;transform:scale(1.04)}}

@media(max-width:560px){.fb-likert{flex-direction:column}.fb-lk{min-height:46px;font-size:12px;padding:12px 10px}}
@media(max-width:480px){.fb-frame{padding:46px 22px 30px}.fb-headline{font-size:31px}.fb-qr-box img{width:150px;height:150px}}
`;

const LIKERT = [
  { v: 1, label: 'Strongly Disagree' },
  { v: 2, label: 'Disagree' },
  { v: 3, label: 'Neutral' },
  { v: 4, label: 'Agree' },
  { v: 5, label: 'Strongly Agree' },
];

const Defs = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
    <defs>
      <linearGradient id="fbGold" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#e7ca72" /><stop offset=".55" stopColor="#c9a84c" /><stop offset="1" stopColor="#8f6f2c" />
      </linearGradient>
      <linearGradient id="fbTeal" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#5fe6da" /><stop offset="1" stopColor="#2bb8ad" />
      </linearGradient>
    </defs>
  </svg>
);

const Corner = ({ pos }) => (
  <svg className={'fb-corner fb-corner-' + pos} width="84" height="84" viewBox="0 0 120 120" aria-hidden="true">
    <g fill="none" stroke="url(#fbGold)" strokeWidth="1.5" strokeLinecap="round">
      <path d="M18 60 L18 18 L60 18" />
      <path d="M26 52 L26 26 L52 26" />
      <path d="M26 26 C 44 28, 52 36, 52 52" />
      <path d="M18 18 C 32 10, 46 10, 58 14" />
      <path d="M18 18 C 10 32, 10 46, 14 58" />
      <path d="M52 52 C 60 44, 66 42, 76 42" />
      <path d="M52 52 C 44 60, 42 66, 42 76" />
    </g>
    <circle cx="52" cy="52" r="2.4" fill="url(#fbGold)" />
    <circle cx="76" cy="42" r="1.7" fill="url(#fbTeal)" />
    <circle cx="42" cy="76" r="1.7" fill="url(#fbTeal)" />
  </svg>
);

const Divider = () => (
  <div className="fb-divider"><i /><span className="fb-diamond" /><i className="r" /></div>
);

const Stars = ({ value, onPick }) => (
  <div className="fb-stars">
    {[1, 2, 3, 4, 5].map(s => (
      <button type="button" key={s} className="fb-star" onClick={() => onPick(s)} aria-label={`${s} of 5`}>
        <svg width="30" height="30" viewBox="0 0 24 24"
          fill={s <= value ? 'url(#fbGold)' : 'none'}
          stroke={s <= value ? 'url(#fbGold)' : 'rgba(154,166,188,.4)'} strokeWidth="1.3" strokeLinejoin="round">
          <path d="M12 2.6l2.9 5.9 6.5.95-4.7 4.58 1.11 6.47L12 17.45 6.19 20.5l1.11-6.47L2.6 9.45l6.5-.95z" />
        </svg>
      </button>
    ))}
    {value > 0 && <span className="fb-star-val">{value} / 5</span>}
  </div>
);

export default function FeedbackPage() {
  const [form, setForm] = useState(null);
  const [status, setStatus] = useState('loading');
  const [answers, setAnswers] = useState({});
  const [errors, setErrors] = useState({});
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [qr, setQr] = useState('');

  useEffect(() => {
    QRCode.toDataURL('https://futurumawards.com/feedback', {
      width: 340, margin: 1, errorCorrectionLevel: 'H',
      color: { dark: '#071327', light: '#ffffff' },
    }).then(setQr).catch(() => {});
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/api/public/feedback');
        if (res.status === 404) { setStatus('none'); return; }
        if (!res.ok) throw new Error();
        const data = await res.json();
        setForm(data);
        setStatus(data.has_submitted ? 'already' : 'ready');
      } catch {
        setError('Unable to load the feedback form. Please refresh the page.');
        setStatus('error');
      }
    })();
  }, []);

  const setAnswer = (qid, type, val) => {
    setAnswers(a => ({ ...a, [qid]: type === 'rating' ? { answer_rating: val } : { answer_text: val } }));
    setErrors(e => { const n = { ...e }; delete n[qid]; return n; });
  };

  const answered = (q) => {
    const a = answers[q.id];
    if (!a) return false;
    return q.question_type === 'rating' ? !!a.answer_rating : !!(a.answer_text || '').trim();
  };

  const allDone = form?.questions?.every(q => !q.is_required || answered(q));

  const submit = async (e) => {
    e.preventDefault();
    const errs = {};
    form.questions.forEach(q => { if (q.is_required && !answered(q)) errs[q.id] = 'This question is required.'; });
    if (Object.keys(errs).length) {
      setErrors(errs);
      setError('Please answer all required questions before submitting.');
      return;
    }
    setSubmitting(true); setError('');
    try {
      const payload = Object.entries(answers).map(([question_id, v]) => ({ question_id, ...v }));
      const res = await fetch('/api/public/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ form_id: form.id, answers: payload }),
      });
      if (res.status === 409) { setStatus('already'); return; }
      if (!res.ok) {
        const d = await res.json().catch(() => ({}));
        throw new Error(d.error || 'Your feedback could not be submitted.');
      }
      setStatus('done');
    } catch (err) {
      setError(err.message || 'Your feedback could not be submitted. Please try again.');
    } finally { setSubmitting(false); }
  };

  const QRBlock = () => qr ? (
    <>
      <Divider />
      <div className="fb-qr-box"><img src={qr} alt="Scan for feedback" /></div>
      <div className="fb-qr-caption">futurumawards.com/feedback</div>
    </>
  ) : null;

  return (
    <div className="fb-wrap">
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <Defs />
      <div className="fb-frame">
        <Corner pos="tl" /><Corner pos="tr" /><Corner pos="bl" /><Corner pos="br" />
        <div className="fb-center">
          <img className="fb-logo" src="/futurum-logo.png" alt="Futurum Innovation Awards" />
          <div className="fb-kicker">Season II · Grand Finale</div>
          <Divider />

          {status === 'loading' && <div className="fb-spin" />}

          {status === 'error' && <div className="fb-error">{error}</div>}

          {status === 'none' && (
            <>
              <div className="fb-closed">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="url(#fbGold)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 11.5a8.4 8.4 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.4 8.4 0 01-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.4 8.4 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" />
                </svg>
              </div>
              <h1 className="fb-headline">Feedback Is Not Yet Open</h1>
              <p className="fb-lead">
                The feedback form will open at the close of the ceremony. Please keep this page open —
                your thoughts help shape the next season.
              </p>
              <QRBlock />
            </>
          )}

          {status === 'already' && (
            <>
              <div className="fb-tick">✓</div>
              <div className="fb-thanks">Thank You</div>
              <p className="fb-lead">
                You have already shared your feedback with us. We are grateful for your time.
              </p>
            </>
          )}

          {status === 'done' && (
            <>
              <div className="fb-tick">✓</div>
              <div className="fb-thanks">Thank You</div>
              <p className="fb-lead">
                Your feedback has been recorded. It will directly inform how we shape the next season
                of the Futurum Innovation Awards.
              </p>
            </>
          )}

          {status === 'ready' && (
            <>
              <h1 className="fb-headline">Your Feedback</h1>
              <p className="fb-lead">
                Two minutes of your time helps us make the next finale better. Questions marked
                <span className="fb-req"> *</span> are required.
              </p>
              <Divider />

              {error && <div className="fb-error" style={{ textAlign: 'left' }}>{error}</div>}

              <form className="fb-form" onSubmit={submit}>
                {form.questions?.map((q, i) => {
                  const a = answers[q.id] || {};
                  const opts = typeof q.options === 'string' ? JSON.parse(q.options) : q.options;
                  return (
                    <div className="fb-q" key={q.id}>
                      <div className="fb-q-num">Question {i + 1} of {form.questions.length}</div>
                      <div className="fb-q-text">
                        {q.question_text}{q.is_required && <span className="fb-req"> *</span>}
                      </div>

                      {q.question_type === 'rating' && q.render_style === 'stars' && (
                        <Stars value={a.answer_rating || 0} onPick={v => setAnswer(q.id, 'rating', v)} />
                      )}

                      {q.question_type === 'rating' && q.render_style === 'likert' && (
                        <div className="fb-likert">
                          {LIKERT.map(l => (
                            <button type="button" key={l.v}
                              className={'fb-lk' + (a.answer_rating === l.v ? ' on' : '')}
                              onClick={() => setAnswer(q.id, 'rating', l.v)}>
                              {l.label}
                            </button>
                          ))}
                        </div>
                      )}

                      {q.question_type === 'multiple_choice' && (
                        <div className="fb-choices">
                          {(opts || []).map(o => (
                            <button type="button" key={o}
                              className={'fb-choice' + (a.answer_text === o ? ' on' : '')}
                              onClick={() => setAnswer(q.id, 'text', o)}>
                              {o}
                            </button>
                          ))}
                        </div>
                      )}

                      {q.question_type === 'text' && (
                        <>
                          <textarea className="fb-textarea" rows={3}
                            value={a.answer_text || ''}
                            onChange={e => setAnswer(q.id, 'text', e.target.value)}
                            placeholder="Share your thoughts…" />
                          <div className="fb-count">{(a.answer_text || '').length} characters</div>
                        </>
                      )}

                      {errors[q.id] && <div className="fb-inline-err">{errors[q.id]}</div>}
                    </div>
                  );
                })}

                <button className="fb-submit" type="submit" disabled={submitting || !allDone}>
                  {submitting ? 'Submitting…' : 'Submit Feedback'}
                </button>
                <div className="fb-fine">Your responses are anonymous · one submission per device</div>
              </form>
            </>
          )}

          <div className="fb-footer">Futurum Innovation Awards</div>
        </div>
      </div>
    </div>
  );
}
